import {
  React,
  Component,
  withRouter,
  withCookies,
  axios,
  routes,
  helpers
} from 'imports/CommonImports';

import {
  CircularProgress,
} from 'material-ui';

import {
  ProjectSummaryList,
  ProjectDistributionGraph,
  ProjectDistributionPie,
  ProjectDistributionPerAreaPie,
  ProjectDistributionPerAreaGraph
} from 'imports/ComponentsImports';


const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    marginLeft: '1em',
  },
  subHeader: {
    margin: '0 0 1em 2em',
  },
  graphsContainer: {
    flex: 1,
    display: 'flex',
  },
  graph: {
    flex: 1,
    margin: '1em'
  },
  listsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  }
}

class Dashboard extends Component {
  constructor(props){
    super(props);
    this.state = {
      user: this.props.cookies.get('user'),
      token: this.props.cookies.get('token'),
      error: false,
      loading: true,
    }
  }

  componentDidMount(){
    this.getData();
  }

  render() {
    if(this.state.error){
      return(
        <div style={{display: 'flex', justifyContent: 'center', marginTop:'20px'}}>
          <p>Error al cargar la etapa en la que se encuentra su empresa. Por favor recarga la página o intenta más tarde.</p>
        </div>
      )
    }
    if(this.state.loading){
      return(
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop:'20px'}}>
            <CircularProgress color='#9e9e9e' size={80} thickness={5} />
          </div>
      )
    }
    return (
      <div style={styles.container}>
        <h1 style={styles.header}> 3. Dashboard </h1>
        <h2 style={styles.subHeader}> 3.3 Datos por área</h2>
        <div style={styles.graphsContainer}>
          <ProjectDistributionGraph style={styles.graph} currency={this.state.dataSummary.currency} indicator={this.state.dataSummary.indicator} title="Distribución del aporte económico por proyecto" data={this.state.dataByArea}/>
          <ProjectDistributionPie style={styles.graph} currency={this.state.dataSummary.currency} indicator={this.state.dataSummary.indicator} title="Distribución del aporte económico por proyecto" data={this.state.dataByArea}/>
        </div>
        <div style={styles.graphsContainer}>
          <ProjectDistributionPerAreaGraph style={styles.graph} currency={this.state.dataSummary.currency} indicator={this.state.dataSummary.indicator} data={this.state.dataByAreaRaw}/>
          <ProjectDistributionPerAreaPie style={styles.graph} currency={this.state.dataSummary.currency} indicator={this.state.dataSummary.indicator} data={this.state.dataByAreaRaw}/>
        </div>
        <div style={styles.listsContainer}>
          {this.state.areas.map((area, i) => {
            return (<ProjectSummaryList key={i} style={styles.graph} title={area} projects={this.state.dataByAreaRaw.filter(data => data.area === area)}/>)
          })}
        </div>
      </div>
    );
  }

  getData = () => {
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.state.token}
    });
    var dataSummary = connection.get(routes.dataSummary(this.state.user.company_id))
    var dataByProject = connection.get(routes.dataByProject(this.state.user.company_id))
    Promise.all([dataSummary, dataByProject])
    .then((responses) => {
      var dataByAreaRaw = responses[1].data;
      var dataByAreaObject = helpers.groupBy(dataByAreaRaw, dataByAreaRaw => dataByAreaRaw.area, dataByAreaRaw => dataByAreaRaw.values)
      var dataByAreaArray = []
      for (var key in dataByAreaObject) {
        if (dataByAreaObject.hasOwnProperty(key)) {
          dataByAreaArray.push({
            name: key,
            values: dataByAreaObject[key].reduce((array1, array2) => {
              return array1.map((value, index) => {
                return value + array2[index];
              });
            }),
          });
        }
      }
      this.setState({
        loading: false,
        error: false,
        dataSummary: responses[0].data,
        dataByArea: dataByAreaArray,
        dataByAreaRaw: dataByAreaRaw,
        areas: Array.from(new Set(dataByAreaRaw.map(project => project.area))),
      })
    })
    .catch((error) => {
      this.setState({
        loading: false,
        error: true,
      });
      console.error(error);
    })
  }
}

export default withRouter(withCookies(Dashboard));



// WEBPACK FOOTER //
// ./src/views/dashboard/DashboardAreaView.js